import React from 'react';
import { inject, observer } from 'mobx-react';
import { Spring, animated } from 'react-spring';

import Button, { buttonHeight, lineHeight, verticalPadding, horizontalPadding } from 'js/components/common/Button';
export { buttonHeight, lineHeight, verticalPadding, horizontalPadding };

function noop() {}

export default inject('page')(
  observer(({ page, onClick, disabled, children, delay, ...rest }) => {
    const stepIsComplete = page.step && page.step.isComplete(page, page.step);
    const isDisabled = typeof disabled !== 'undefined' ? disabled : !stepIsComplete;
    const isSubmitting = page.isSubmitting;
    return (
      <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }} delay={typeof delay === 'undefined' ? 300 : delay}>
        {animation => (
          <animated.div style={animation}>
            <Button
              type="submit"
              isLoading={isSubmitting}
              disabled={isDisabled}
              onClick={() =>
                (disabled === 'false' || stepIsComplete) && !disabled && !isSubmitting && (onClick || noop)()
              }
              {...rest}>
              {children || 'Continue'}
            </Button>
          </animated.div>
        )}
      </Spring>
    );
  }),
);
